import { IconCircles, IconFolder } from '@rossum/ui/icons/tabler';
import { Stack } from '@rossum/ui/material';
import Stats, { StatsType } from '../components/Stats';

type UserStatsProps = {
  queuesCount: number;
  workspacesCount: number;
};

export const UserStats = ({ queuesCount, workspacesCount }: UserStatsProps) => {
  const stats: StatsType[] = [
    {
      value: workspacesCount,
      Icon: IconCircles,
      title: 'containers.settings.stats.user.activeWorkspaces' as const,
      type: 'workspaces',
    },
    {
      value: queuesCount,
      Icon: IconFolder,
      title: 'containers.settings.stats.user.assignedQueues' as const,
      type: 'queues',
    },
  ];

  return (
    <Stack
      direction="row"
      spacing={2}
      useFlexGap
      sx={{ my: 2, flexWrap: 'wrap' }}
    >
      <Stats stats={stats} />
    </Stack>
  );
};
